import { render } from "./BarcodeIcon.vue?vue&type=template&id=c491a19e&scoped=true"
import script from "./BarcodeIcon.vue?vue&type=script&lang=ts"
export * from "./BarcodeIcon.vue?vue&type=script&lang=ts"

import "./BarcodeIcon.vue?vue&type=style&index=0&id=c491a19e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c491a19e"

export default script